import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Twitter = ({ className }) => {
  return (
    <svg
      viewBox='0 0 677 550'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-twitter', { [className]: className })}
    >
      <path
        d='M677 63.4615C651.612 76.1538 626.225 80.3846 596.606 84.6154C626.225 67.6923 647.381 42.3077 655.844 8.46153C630.456 25.3846 600.837 33.8462 566.987 42.3077C541.6 16.9231 503.519 0 465.438 0C376.581 0 308.881 84.6154 330.038 169.231C215.794 165 114.244 110 42.3125 25.3846C4.23125 88.8462 25.3875 169.231 84.625 211.538C63.4688 211.538 42.3125 203.077 21.1562 194.615C21.1562 258.077 67.7 317.308 131.169 334.231C110.013 338.462 88.8563 342.692 67.7 338.462C84.625 393.462 135.4 435.769 198.869 435.769C148.094 473.846 71.9313 495 0 486.538C63.4688 524.615 135.4 550 211.562 550C469.669 550 613.531 334.231 605.069 135.385C634.687 118.462 660.075 93.0769 677 63.4615Z'
        fill='currentColor'
      />
    </svg>
  );
};

Twitter.propTypes = {
  className: PropTypes.string,
};

export default Twitter;
